const phases = [
  { label: 'Wireframy', done: true },
  { label: 'Dizajn', done: true },
  { label: 'Vývoj', active: true },
  { label: 'Testovanie', done: false },
  { label: 'Spustenie', done: false },
];

const pendingTasks = [
  { label: 'Schváliť finálny dizajn', date: 'Dnes', who: 'Vy', priority: true },
  { label: 'Dodať produktové fotografie', date: '25.3.', who: 'Vy', priority: true },
];

const metrics = [
  { label: 'Návštevy', value: '4 821', change: '+18 %', up: true },
  { label: 'Kľúč. slová', value: '312', change: '+24 %', up: true },
  { label: 'Konverzie', value: '47', change: '+9 %', up: true },
  { label: 'CPC', value: '0.34 €', change: '-12 %', up: false },
];

const activeServices = [
  { label: 'SEO optimalizácia', price: '149 €' },
  { label: 'Google Ads správa', price: '199 €' },
  { label: 'Social media management', price: '299 €' },
];

export default function PortalPrehled() {
  return (
    <div className="p-6 space-y-5 overflow-y-auto h-full">
      {/* Project progress */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5">
        <div className="flex items-start justify-between mb-4">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="bg-amber-500/10 border border-amber-500/20 text-amber-400 text-xs px-2.5 py-0.5 rounded-full font-semibold">V progrese</span>
              <span className="text-zinc-600 text-xs">Termín: 15. apríl 2025</span>
            </div>
            <p className="text-white font-bold text-base">Redesign e-shopu – Fáza 3</p>
          </div>
          <div className="text-right">
            <span className="text-orange-400 font-black text-3xl leading-none">65</span>
            <span className="text-orange-400 font-bold text-base">%</span>
            <p className="text-zinc-600 text-xs mt-0.5">dokončené</p>
          </div>
        </div>

        <div className="h-2 bg-zinc-800 rounded-full overflow-hidden mb-4">
          <div className="h-full w-[65%] bg-gradient-to-r from-orange-500 to-amber-400 rounded-full transition-all duration-700" />
        </div>

        <div className="flex flex-wrap gap-4">
          {phases.map((ph) => (
            <div key={ph.label} className="flex items-center gap-1.5">
              <div className={`w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 ${ph.done ? 'bg-emerald-500' : ph.active ? 'bg-orange-500 ring-2 ring-orange-500/30' : 'bg-zinc-700'}`}>
                {ph.done && <i className="ri-check-line text-white" style={{ fontSize: 10 }} />}
                {ph.active && <div className="w-1.5 h-1.5 bg-white rounded-full" />}
              </div>
              <span className={`text-xs font-medium ${ph.done ? 'text-emerald-400' : ph.active ? 'text-orange-400' : 'text-zinc-600'}`}>{ph.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Two columns */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* Pending tasks */}
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5">
          <div className="flex items-center justify-between mb-4">
            <p className="text-white font-bold text-sm">Čakajúce úlohy</p>
            <span className="bg-orange-500/10 border border-orange-500/20 text-orange-400 text-xs px-2.5 py-0.5 rounded-full font-semibold">
              {pendingTasks.length} nových
            </span>
          </div>
          <div className="space-y-3">
            {pendingTasks.map((t) => (
              <div key={t.label} className="flex items-center gap-3 p-3 bg-zinc-950/60 border border-zinc-800 rounded-xl">
                <div className="w-8 h-8 flex items-center justify-center bg-orange-500/10 border border-orange-500/20 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-orange-400 text-sm" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-zinc-200 text-sm font-medium truncate">{t.label}</p>
                  <p className="text-zinc-600 text-xs mt-0.5">{t.who}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <span className={`text-xs font-bold ${t.date === 'Dnes' ? 'text-red-400' : 'text-orange-400'}`}>{t.date}</span>
                  {t.priority && (
                    <div className="mt-1 bg-red-500/10 border border-red-500/20 text-red-400 text-[9px] px-1.5 py-0.5 rounded-full font-semibold">Priorita</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Active services */}
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5">
          <div className="flex items-center justify-between mb-4">
            <p className="text-white font-bold text-sm">Aktívne služby</p>
            <span className="bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs px-2.5 py-0.5 rounded-full font-semibold">3 aktívne</span>
          </div>
          <div className="space-y-2.5">
            {activeServices.map((s) => (
              <div key={s.label} className="flex items-center justify-between py-2 border-b border-zinc-800/50 last:border-0">
                <div className="flex items-center gap-2.5">
                  <span className="w-2 h-2 bg-emerald-400 rounded-full flex-shrink-0" />
                  <span className="text-zinc-300 text-sm">{s.label}</span>
                </div>
                <span className="text-white text-sm font-bold">{s.price}</span>
              </div>
            ))}
          </div>
          <div className="mt-3 pt-3 border-t border-zinc-800 flex items-center justify-between">
            <span className="text-zinc-500 text-xs">Celkom mesačne</span>
            <span className="text-orange-400 text-lg font-black">647 €<span className="text-zinc-500 text-xs font-medium">/mes</span></span>
          </div>
        </div>
      </div>

      {/* Latest report */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-white font-bold text-sm">Posledný report</p>
            <p className="text-zinc-500 text-xs mt-0.5">Február 2025</p>
          </div>
          <button className="flex items-center gap-1.5 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-300 hover:text-white text-xs font-semibold px-3 py-2 rounded-lg cursor-pointer transition-all whitespace-nowrap">
            <i className="ri-download-2-line text-orange-400 text-sm" />
            Stiahnuť PDF
          </button>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {metrics.map((m) => (
            <div key={m.label} className="bg-zinc-950/60 border border-zinc-800/50 rounded-xl p-4 text-center">
              <p className="text-white font-black text-xl leading-none mb-1">{m.value}</p>
              <p className="text-zinc-600 text-xs mb-2">{m.label}</p>
              <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${m.up ? 'bg-emerald-500/10 text-emerald-400' : 'bg-orange-500/10 text-orange-400'}`}>{m.change}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
